import React from "react";
import PropTypes from "prop-types";
import { PlaceShape } from "../../../Srp/shapes";
import { Subscribe } from "unstated";
import SrpContainer from "../../../Srp/containers/SrpContainer";
import LinkCrumb from "./LinkCrumb";
import AdminOptions from "./AdminOptions";

const getPath = (location, slug) => {
  const { pathname, search } = location;
  if (/(\/book-venue)/.test(pathname) && /(\/venue-)/.test(pathname)) {
    const path = pathname
      .toLowerCase()
      .replace(/(\/book-venue-)([^/]*)(.*)/, `$1${slug}$3`);
    return path + search;
  }

  return `/book-venue-${slug}`;
};

const Breadcrumbs = ({ location, place, appended }) => {
  if (!place) return null;

  const { parents } = place;
  if (parents.length < 1) return null;

  const output = parents
    .map((p, i) => {
      if (typeof p !== "object" || !p.slug) return null;

      const url = getPath(location, p.slug);

      if (url === location.pathname) {
        return <b key={`crumb${i}`}>{p.name}</b>;
      }

      return <LinkCrumb key={`crumb${i}`} place={p} url={url} />;
    })
    .filter((p) => p);

  if (appended) {
    appended.forEach((a, i) => {
      if (typeof a !== "object") return;

      const item = a.href ? (
        <a key={a.href} href={a.href}>
          {a.text}
        </a>
      ) : (
        <b>{a.text}</b>
      );
      output.unshift(item);
    });
  }
  // console.log(output.reverse())
  return (
    <div className="srp-pages-listing">
      <AdminOptions />
      <div className="breadcrumb">
        {output
          .reverse()
          .map((e, i) => (i > 0 ? [<span key={`chev${i}`} />, e] : e))}
      </div>
    </div>
  );
};

Breadcrumbs.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }),
  place: PlaceShape.isRequired,
  appended: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string.isRequired,
    })
  ),
};

const BreadCrumbsContainer = () => (
  <Subscribe to={[SrpContainer]}>
    {({ state: { location, data } }) => (
      <Breadcrumbs location={location} place={data.place_model} />
    )}
  </Subscribe>
);

export default BreadCrumbsContainer;
